module.exports = __webpack_public_path__ + "media/assets/images/category/Passover@2x-a88896292bf9a6bd64f96c23672ed7ef.png";